import { render, staticRenderFns } from "./v_Terms_Disclaimer.vue?vue&type=template&id=c34e51cc&scoped=true&"
import script from "./v_Terms_Disclaimer.vue?vue&type=script&lang=js&"
export * from "./v_Terms_Disclaimer.vue?vue&type=script&lang=js&"
import style0 from "./v_Terms_Disclaimer.vue?vue&type=style&index=0&id=c34e51cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c34e51cc",
  null
  
)

export default component.exports